import { faComment,  faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faFacebook , faWhatsapp ,faSquareWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope,  faMessage} from "@fortawesome/sharp-light-svg-icons";
import { faEnvelope as Email , faMessage as message} from "@fortawesome/sharp-solid-svg-icons";


export interface ITheme {
    default: string;
    hover: string;
    selected: string;
    primaryText: string;
    secondaryText: string;
    contentText: string;
    unselectedIcon: string;
    neutral: string;
    primary: string;
    idle: string;
    break: string;
    alert: string;
    highlightedTask: string;
};

export const defaultColorTheme: ITheme = {
    default: "#B5B7B7",
    hover: "#A4A4A4",
    selected: "#1B1C1A",
    primaryText: "#1B1C1A",
    secondaryText: "#9A9A9A",
    contentText: "#9E9E9E",
    unselectedIcon: "#B5B7B5",
    neutral: "#F5F5F5",
    primary: "#FFFFFF",
    idle: "#65E98A",
    break: "#FFB341",
    alert: "#FF4D4D",
    highlightedTask: "#F3F7F8"
};

export const dxpLayout = {
    workItemHeaderHeight: "2rem",
}

export const getMediaColor = (mediaType: string,channelType:string) => {
    switch (mediaType) {
        case "Messaging":
        switch( channelType){
                case "whatsapp":
                    return "#25D366";
                case "facebook":
                    return "#316FF6";
                default:
                     return "#000000";
            }
        case "Webchat":
            return "#5194FF";
        case "Voice":
            return "#65E98A";
        case "Email":
            return "#5C8898";
        default:
            return "#000000";
    }
};

export const getMediaIcon = (mediaType: string, channelType:string, selected:boolean) => {
    switch (mediaType) {
        case "Messaging":
            switch( channelType){
                case "whatsapp": 
                   return selected ? faSquareWhatsapp : faWhatsapp;                   
                case "facebook":
                    return selected ? faFacebook : faFacebookF;
                case "Email":
                    return selected? faEnvelope : faMessage;
                default:
                    return selected? faComment : faWhatsapp;
            }
        case "Webchat":
            return selected ? message : faMessage;
        case "Voice":
            return faPhone;
        case "Email":
            return selected ? Email: faEnvelope ;
        default:
            return faComment;
    }
};